var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",on:{"click":_vm.onLogout}},[_c('span',{staticClass:"no-icon"},[_vm._v("Log out")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }